import moment from 'moment';
import * as types from '../../constants/assertReports/actionType';
import { Tune } from '@material-ui/icons';

const initialState = {
    softwarePulisher: [],
    os: [],
    isLoadingPulicherOs: true,
    pulisherTable: [{ head: [], body: [] }],
    osTable: [{ head: [], body: [] }],
    Manufactures: [],
    ManufacturesTable: [{ head: [], body: [] }],
    Anitivirus: [],
    AnitivirusTable: [{ head: [], body: [] }],
    SystemType: [],
    SystemTypeTable: [{ head: [], body: [] }],
    isLoadingTable: true,
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_GET_0S_PUBLISHER_COUNT_DEATILS:
            return {
                ...state,
                softwarePulisher: [],
                os: [],
                Manufactures: [],
                Anitivirus: [],
                SystemType: [],
                isLoadingPulicherOs: true
            }
        case types.SUCCESS_GET_0S_PUBLISHER_COUNT_DEATILS:
            return {
                ...state,
                softwarePulisher: action.data.list==null?[]:action.data.list,
                os: action.data.list1==null?[]:action.data.list1,
                Manufactures: action.data.manufacturer==null?[]:action.data.manufacturer,
                Anitivirus: action.data.antivirus==null?[]:action.data.antivirus,
                SystemType: action.data.computerType==null?[]:action.data.computerType,
                isLoadingPulicherOs: false
            }
        case types.FAILED_GET_0S_PUBLISHER_COUNT_DEATILS:
            return {
                ...state,
                softwarePulisher: [],
                os: [],
                Manufactures: [],
                Anitivirus: [],
                SystemType: [],
                isLoadingPulicherOs: false
            }

        //table
        case types.FETCH_GET_OS_PUBLISHER_DETAILS_WITH_NAME:
            return {
                ...state,
                pulisherTable: [],
                osTable: [],
                ManufacturesTable: [],
                AnitivirusTable: [],
                SystemTypeTable: [],
                isLoadingTable: true
            }
        case types.SUCCESS_GET_OS_DETAILS_WITH_NAME:
            var data = []
            action.data.list.map(i => {
                data.push([{ SystemName: i.SystemName,UserName:i.UserNames  },i.UserNames, i.OSProduct, i.ComputerModel, i.Manufacturer, i.CreatedAt])
            })
            return {
                ...state,
                pulisherTable: [],
                ManufacturesTable:[],
                AnitivirusTable:[],
                SystemTypeTable:[],
                osTable: {
                    head: [
                        { label: "System Name", align: "left" },
                        { label: "User Name", align: "left" },
                        { label: "OS Product", align: "left" },
                        { label: "Computer Model ", align: "left" },
                        { label: "Manufacuture ", align: "left" },
                        { label: "Created On", align: "left" },
                    ],
                    body: data,
                },
                isLoadingTable: false
            }
        case types.SUCCESS_GET_PUBLISHER_DETAILS_WITH_NAME:
            var data = []
            action.data.list.map(i => {
                data.push([{ SystemName: i.SystemName,UserName:i.UserNames },i.UserNames, i.Name, i.Version, i.Publisher,])
            })
            return {
                ...state,
                pulisherTable: {
                    head: [
                        { label: "System Name", align: "left" },
                        { label: "User Name", align: "left" },
                        { label: "Application Name", align: "left" },
                        { label: "Version ", align: "left" },
                        { label: "Publisher ", align: "left" },
                    ],
                    body: data,
                },

                osTable: [],
                ManufacturesTable:[],
                AnitivirusTable:[],
                SystemTypeTable:[],
                isLoadingTable: false
            }
        case types.SUCCESS_GET_MANUFATURE_DETAILS_WITH_NAME:
            var data = []
            action.data.list.map(i => {
                data.push([{ SystemName: i.SystemName ,UserName:i.UserNames },i.UserNames, i.Manufacturer, i.Model, i.CreatedAt,])
            })
            return {
                ...state,
                ManufacturesTable: {
                    head: [
                        { label: "System Name", align: "left" },
                        { label: "User Name", align: "left" },
                        { label: "Manufacturer", align: "left" },
                        { label: "Computer Model ", align: "left" },
                        { label: "Created On ", align: "left" },
                    ],
                    body: data,
                },

                osTable: [],
                pulisherTable: [],
                AnitivirusTable:[],
                SystemTypeTable:[],
                isLoadingTable: false
            }
        case types.SUCCESS_GET_ANTIVIRUS_DETAILS_WITH_NAME:
            var data = []
            action.data.list.map(i => {
                data.push([{ SystemName: i.SystemName,UserName:i.UserNames  },i.UserNames, i.Antivirus, {Status:i.Status}, {UpdateStatus:i.UpdateStatus},])
            })
            return {
                ...state,
                AnitivirusTable: {
                    head: [
                        { label: "System Name", align: "left" },
                        { label: "User Name", align: "left" },
                        { label: "Antivirus", align: "left" },
                        { label: "Status", align: "left" },
                        { label: "Update Status", align: "left" },
                    ],
                    body: data,
                },

                osTable: [],
                pulisherTable: [],
                ManufacturesTable:[],
                SystemTypeTable:[],
                isLoadingTable: false
            }
            case types.SUCCESS_GET_SYSTEM_TYPE_DETAILS_WITH_NAME:
                var data = []
                action.data.list.map(i => {
                    data.push([{ SystemName: i.SystemName,UserName:i.UserNames  },i.UserNames, i.ComputerType, i.ComputerModel, i.OS,i.Manufacturer,])
                })
                return {
                    ...state,
                    SystemTypeTable: {
                        head: [
                            { label: "System Name", align: "left" },
                            { label: "User Name", align: "left" },
                            { label: "Computer Type", align: "left" },
                            { label: "Computer Model", align: "left" },
                            { label: "OS ", align: "left" },
                            { label: "Manufacturer", align: "left" },
                        ],
                        body: data,
                    },
    
                    osTable: [],
                    pulisherTable: [],
                    ManufacturesTable:[],
                    AnitivirusTable:[],
                    isLoadingTable: false
                }
        case types.FAILED_GET_OS_PUBLISHER_DETAILS_WITH_NAME:
            return {
                ...state,
                pulisherTable: [],
                osTable: [],
                ManufacturesTable: [],
                AnitivirusTable: [],
                SystemTypeTable: [],
                isLoadingTable: false
            }
        default:
            return state
    }
}
export default reducer
